export enum UserActionTypes {
    USER_REQUEST_SEND = 'user_request_send',
    USER_ERROR = 'user_error',
    USER_SUCCESS = 'user_success',
    
    USER_CREATE_REQUEST = 'user_create_request',
    USER_CREATE_SUCCESS = 'user_create_success',
    USER_CREATE_ERROR = 'user_create_error',

    USER_DELETE_REQUEST = 'user_delete_request',
    USER_DELETE_SUCCESS = 'user_delete_success',
    USER_DELETE_ERROR = 'user_delete_error',

    USER_UPDATE_REQUEST = 'user_update_request',
    USER_UPDATE_SUCCESS = 'user_update_success',
    USER_UPDATE_ERROR = 'user_update_error',
}